export function HorizontalRuleCard() {
    return (
        <hr className="m-0 block h-[1px] border-0 border-t border-grey-300" />
    );
}
